<template>
  <div class="box-body" style="padding-top: 20px;">
    <div class="empty-tip" v-if="groupList.length===0" @click="$router.push(`/erp-order-detail-manager`)">请先设置品番分组，点击前往。</div>
    <i class="el-icon-refresh" v-if="groupList.length>0" @click="reload()" style="position: absolute;top: 10px;right: 10px;cursor: pointer;font-size: 18px;"></i>
    <div class="product-list-box" v-for="(product,$index) in groupList" :key="product.id">
      <div class="table-bar" style="margin-bottom: 0px;">
        <div class="title" :id="`title${$index}`">
          <span>{{ product.groupName }}</span>
          <span>发货数：{{product.checkOutCount}}</span>
        </div>
      </div>
      <el-form
          :model="product"
          ref="dataForm"
          label-width="0"
      >
        <el-table :data="product.bomList" :summary-method="getSummaries" :id="'table'+$index" :loading="dataListLoading"
                  show-summary>
          <el-table-column label="品名" min-width="120" align="center" prop="name" :show-overflow-tooltip="true">
          </el-table-column>
          <el-table-column
              label="颜色"
              prop="color"
              header-align="center"
              align="center"
              min-width="100"
              :show-overflow-tooltip="true"
          >
          </el-table-column>
          <el-table-column
              label="规格"
              prop="size"
              header-align="center"
              align="center"
              min-width="100"
              :show-overflow-tooltip="true"
          >
          </el-table-column>
          <el-table-column
              label="幅宽"
              prop="attr1"
              header-align="center"
              align="center"
              min-width="100"
              :show-overflow-tooltip="true"
          >
          </el-table-column>
          <el-table-column
              label="克重"
              prop="attr2"
              header-align="center"
              align="center"
              min-width="100"
              :show-overflow-tooltip="true"
          >
          </el-table-column>
          <el-table-column
              label="理论单耗"
              prop="count"
              header-align="center"
              align="center"
              width="100"
          >
          </el-table-column>
          <el-table-column
              label="实际单耗"
              prop="realCount"
              header-align="center"
              align="center"
              width="100"
          >
          </el-table-column>
          <el-table-column
              label="开票单价"
              prop="price"
              header-align="center"
              align="center"
              width="100"
          >
          </el-table-column>
          <el-table-column
              label="调整金额"
              prop="otherAmount"
              header-align="center"
              align="center"
              width="100"
          >
          </el-table-column>
          <el-table-column
              label="金额"
              prop="totalPrice"
              header-align="center"
              align="center"
              width="100"
          >
          </el-table-column>
        </el-table>
      </el-form>
    </div>
  </div>
</template>
<script>
/**
 * 单位成本分析,按商品分组显示
 */
import money from '@/components/money.vue'
import mixinViewModule from '@/mixins/view-module'
import BigNumber from 'bignumber.js'
import { isNumber, moneyValidator } from '@/utils/validate'
import XLSX from 'xlsx'
import SelOrderDetailDialog from '@/views/modules/erp/order/detail/SelOrderDetailDialog.vue'

export default {
  mixins: [mixinViewModule],
  props: {
    agreementId: ''
  },
  components: { SelOrderDetailDialog,money },
  data () {
    return {
      productNameSetting:['code','skuCode','name','color','size'],
      pageLoading: null,
      mixinViewModuleOptions: {
        getDataListURL: '/trade/agreement/detail/list',
        getDataListIsPage: false,
        activatedIsNeed: false,
      },
      groupList:[],
      dataForm: {
        agreementId: '',
        calculate: '1'
      },
      currentChange: null,
      exporting: false,
      detailRule: {
        money: [
          { validator: moneyValidator, trigger: 'change' },
        ],
        count: [
          {
            validator: function (rule, value, callback) {
              if (!isNumber(value)) {
                callback(new Error('请输入正确的数量'))
                return
              }
              callback()
            },
            trigger: 'change',
          },
        ]
      }
    }
  },
  watch: {
    agreementId: {
      handler: function (newVal) {
        if (newVal && newVal !== '') {
          this.dataForm.agreementId = newVal
          this.pageLoading = this.$loading()
          this.getDataList()
        } else {
          this.dataList = []
        }
      },
      immediate: true,
    },
  },
  mounted(){
    let productNameSetting=localStorage.getItem('product_name_setting')
    if(productNameSetting){
      this.productNameSetting=JSON.parse(productNameSetting)
    }
  },
  methods: {
    // 导出table数据
    exportTableData (orderCode) {
      this.exporting = true
      this.$nextTick(() => {
        try {
          let book = XLSX.utils.book_new()
          for (let i = 0; i < this.dataList.length; i++) {
            let table = document.querySelector('#table' + i)
            let sheet = XLSX.utils.table_to_sheet(table)
            let product = this.dataList[i]
            // 品番号，规格，数量
            let sheetName = `【${product.checkInCount}】${this.getProductName(product)} `
            if(sheetName.length>25){
              sheetName=sheetName.substring(0,25)
            }
            sheetName=(i+1)+'.'+sheetName.replaceAll(`\\`,'').replaceAll('/','').replaceAll('?','').replaceAll('*','').replaceAll('[','').replaceAll(']','')
            XLSX.utils.book_append_sheet(book, sheet, sheetName)
          }
          XLSX.writeFile(book, `${orderCode}成本核价单${new Date().getTime()}.xlsx`)
        } catch (e) {
          console.log(e)
        } finally {
          this.exporting = false
        }
      })
    },
    getSummaries (param) {
      const { columns, data } = param
      const sums = []
      sums[0] = '合计'
      let totalPrice = new BigNumber(0)
      if (!data || data.length === 0) {
        return sums
      }
      data.forEach((row) => {
        const rowTotalPrice = new BigNumber(row['totalPrice'])
        if (rowTotalPrice.isNaN()) {
          return
        }
        totalPrice = totalPrice.plus(rowTotalPrice)
      })
      sums[columns.length - 1] = totalPrice.toFixed(5)
      return sums
    },
    getProductName(product){
      let defaultKeys=['code','skuCode','name','color','size']
      let fullNameAttr=[]
      defaultKeys.forEach(dk=>{
        if(!this.productNameSetting.find(k=>k===dk)){
          return
        }
        fullNameAttr.push(product[dk])
      })
      return fullNameAttr.join(' ')
    },
    afterTableBinding () {
      this.pageLoading.close()
    },
    beforeTableBinding (dataList) {
      if (!dataList || dataList.length === 0) {
        return
      }
      dataList.forEach((item, pi) => {
        if (!item.bomList) {
          item.bomList = []
        }
        item.hasBom = item.bomList.length > 0
        let tmpId = pi + 1
        item.bomList.push({
          id: tmpId++,
          name: '加工费',
          price: item.makeCost,
          count: 1,
          type: 'virtual',
          realCount: 1,
        })
        item.bomList.push({
          id: tmpId++,
          name: '包装检品费',
          price: item.checkCost,
          count: 1,
          type: 'virtual'

        })
        item.bomList.push({
          id: tmpId++,
          name: '纸箱费',
          price: item.packCost,
          count: 1,
          type: 'virtual',
          realCount: 1,
        })
        item.bomList.push({
          id: tmpId++,
          name: '中棉',
          price: item.cottonCost,
          count: 1,
          type: 'virtual',
          realCount: 1,
        })
        //其他费用均摊
        if (item.otherCost) {
          item.otherCost = JSON.parse(item.otherCost)

          item.otherCost.forEach(cost => {
            item.bomList.push({
              id: cost.categoryName,
              name: cost.categoryName,
              price: cost.amount,
              count: 1,
              totalPrice: cost.amount,
              type: 'virtual',
              realCount: 1,
            })
          })
        }
        item.bomList.forEach(bom => {
          let otherAmount = bom.otherAmount ? bom.otherAmount : 0
          let realCount = bom.realCount && bom.realCount > 0 ? bom.realCount : bom.count
          bom.totalPrice = new BigNumber(bom.price).multipliedBy(realCount).plus(otherAmount).toFixed(5)
          if (!bom.type) {
            bom.type = 'bom'
          }
        })
      })
      try{
        let tmpGroupList=[]
        for(let i=dataList.length-1;i>=0;i--){
          let row=dataList[i]
          if(!row.groupName){
            row.groupName=this.getProductName(row)
          }
          let group=tmpGroupList.find(t=>t.groupName===row.groupName)
          if(group){
            group.checkOutCount=new BigNumber(group.checkOutCount).plus(row.checkOutCount).toFixed(3)
          }else{
            tmpGroupList.push(row)
          }
          this.groupList=tmpGroupList
        }
      }catch(e){
        console.log('1111',e)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.empty-tip{
  display: flex;
  justify-content: center;
  cursor: pointer;
  font-size: 18px;
  font-weight: 500;
}
.empty-tip:hover{
  text-decoration: underline;
  color: #409EFF;
}
.box-body {
  width: 100%;

  .product-list-box {
    margin: 10px;
    border: solid 1px #f1f4f5;

    .title {
      font-weight: 500;
      font-size: 16px;
      line-height: 150%;
      margin: 10px;
    }
  }
}
</style>
